import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { Radio, Typography } from '@material-ui/core';
import GatewayModel from '../../model/gateway';

const useStyles = makeStyles((theme) => ({
    radioRed: {
        '&$radioChecked': {
            color: 'red',
        },
    },
    radioYellow: {
        '&$radioChecked': {
            color: '#FFAA00',
        },
    },
    radioGreen: {
        '&$radioChecked': {
            color: 'green',
        },
    },
    radioGray: {
        '&$radioChecked': {
            color: 'gray',
        },
    },
    labelRed: {
        color: 'red',
    },
    labelYellow: {
        color: '#FFAA00',
    },
    labelGreen: {
        color: 'green',
    },
    radioChecked: {
        paddingLeft: 0,
    },
    statusLabel: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    }
}));

export default function GatewayStatusLabel({ status }) {
    const { t } = useTranslation(['gateway']);
    const classes = useStyles();
    let label = t('gateway:Backlog');
    if (GatewayModel.GATEWAY_STAT_STATUS_VALUES[status]) {
        label = t(`${GatewayModel.GATEWAY_STAT_STATUS_VALUES[status]}`);
    }

    return <Typography align='left' variant='subtitle2' className={classes.statusLabel}>
        <Radio
            disabled={true}
            checked={true}
            classes={{
                ...(status && { root: classes[`radio${GatewayModel.GATEWAY_STAT_STATUS_COLORS[status]}`] }),
                checked: classes.radioChecked,
            }}
        />
        <div>{label}</div>
    </Typography>;
};